module.exports = __webpack_public_path__ + "assets/Maritime.b28eb4ae.svg";